import { io } from 'socket.io-client'
import { ISocket } from '@/store/middleware/socket.ts'

export const SocketIO = (function () {
  let instance: ISocket | null = null

  function Singleton(): ISocket {
    // Private members
    const doNotConnect = globalThis.IS_STORYBOOK
    const socket = doNotConnect ? null : io(import.meta.env.VITE_API_URL)
    socket?.on('connect', () => {
      console.log('Socket connected')
    })
    // Public members
    return {
      emit(key, payload) {
        socket?.emit(key, payload)
      },
      listen(key, cb) {
        if (!socket) throw new Error('Missing socket')
        // Prevent from listening twice
        else if (socket.hasListeners(key)) socket.removeListener(key)
        socket.on(key, cb)
      },
    }
  }

  return {
    getInstance: function (): ISocket {
      if (!instance) instance = Singleton()
      return instance
    },
  }
})()
